import { useParams, Link } from 'react-router-dom';
import { offerings } from './offeringsData';
import PageHeader from './PageHeader';
import SnailOnly from './SnailOnly';
import EnquiryForm from './EnquiryForm';
import './EventPage.css';

export default function OfferingPage() {
  const { slug } = useParams();
  const offering = offerings.find(o => o.slug === slug);

  if (!offering) {
    return (
      <div className="event-page-not-found">
        <p>Workshop not found.</p>
        <Link to="/" className="btn btn-outline-dark">&larr; Back to home</Link>
      </div>
    );
  }

  return (
    <div className="event-page">
      <PageHeader />

      {/* Hero */}
      <div
        className="event-page-hero"
        style={{
          backgroundImage: `url(${offering.heroImg || offering.img})`,
          backgroundPosition: offering.heroPosition || 'center',
          height: offering.heroHeight,
        }}
      >
        <div className="event-page-hero-overlay">
          <Link to="/#events" className="event-page-back">&larr; All workshops</Link>
        </div>
        <SnailOnly className="snail-watermark" />
      </div>

      <div className="event-page-body">
        <div className="event-page-inner">

          {/* Title */}
          <h1 className="event-page-title">{offering.title}</h1>

          {/* Key details panel */}
          <div className="event-details-panel">
            <div className="event-detail-item">
              <span className="event-detail-label">Duration</span>
              <span className="event-detail-value">{offering.duration}</span>
            </div>
            <div className="event-detail-item">
              <span className="event-detail-label">Group size</span>
              <span className="event-detail-value">Up to {offering.pricing.max} participants</span>
            </div>
            <div className="event-detail-item">
              <span className="event-detail-label">Min. booking</span>
              <span className="event-detail-value event-detail-price">{offering.pricing.min}{offering.pricing.minNote ? ` ${offering.pricing.minNote}` : ''}</span>
            </div>
            <div className="event-detail-item">
              <span className="event-detail-label">Per extra person</span>
              <span className="event-detail-value">{offering.pricing.extra}{offering.pricing.extraNote ? ` ${offering.pricing.extraNote}` : ''}</span>
            </div>
          </div>

          {/* Book button — early, above the fold */}
          <div className="event-page-cta">
            <a href="#enquire" className="btn btn-primary event-page-book-btn">
              Enquire to Book &rarr;
            </a>
          </div>

          {/* Description */}
          <p className="event-page-desc">{offering.desc}</p>

          {/* Gallery */}
          {offering.images && offering.images.length > 0 && (
            <div className="event-page-gallery">
              {offering.images.map((src, i) => (
                <img key={i} src={src} alt="" className="event-page-gallery-img" />
              ))}
            </div>
          )}

          {/* What's included */}
          {offering.includesSummary && (
            <div className="event-page-section">
              <h3 className="event-page-section-title">What's included</h3>
              <ul className="event-page-includes-list">
                {offering.includesSummary.map(item => <li key={item}>{item}</li>)}
              </ul>
            </div>
          )}

          {/* What to bring */}
          {offering.bring && (
            <div className="event-page-section">
              <h3 className="event-page-section-title">What to bring</h3>
              <p className="event-page-bring">{offering.bring}</p>
            </div>
          )}

          {/* Embedded enquiry form */}
          <div className="event-page-section event-page-enquiry" id="enquire">
            <h3 className="event-page-section-title">Enquire to book</h3>
            <p className="event-page-enquiry-sub">
              Tell us a bit about your group and when you're thinking of gathering – we'll be in touch with a proposal for {offering.title}.
            </p>
            <EnquiryForm defaultSessions={offering.title} />
          </div>

          {/* Bottom actions */}
          <div className="event-page-actions">
            <Link to="/#events" className="btn btn-outline-dark">&larr; All workshops</Link>
          </div>

        </div>
      </div>
    </div>
  );
}
